export enum IconFontType {
    /* BEGIN GENERATED CODE */

    /**
     * Icon 'Accepted'
     */
    Accepted = 1,

    /**
     * Icon 'access'
     */
    Access,

    /**
     * Icon 'AccountActivity'
     */
    AccountActivity,

    /**
     * Icon 'add'
     */
    Add,

    /**
     * Icon 'addTo'
     */
    AddTo,

    /**
     * Icon 'alert'
     */
    Alert,

    /**
     * Icon 'arrowLeft'
     */
    ArrowLeft,

    /**
     * Icon 'arrowRight'
     */
    ArrowRight,

    /**
     * Icon 'at'
     */
    At,

    /**
     * Icon 'attach'
     */
    Attach,

    /**
     * Icon 'calendar'
     */
    Calendar,

    /**
     * Icon 'chat'
     */
    Chat,

    /**
     * Icon 'checkMark'
     */
    CheckMark,

    /**
     * Icon 'chevronDown'
     */
    ChevronDown,

    /**
     * Icon 'chevronLeft'
     */
    ChevronLeft,

    /**
     * Icon 'chevronRight'
     */
    ChevronRight,

    /**
     * Icon 'chevronUp'
     */
    ChevronUp,

    /**
     * Icon 'circleEmpty'
     */
    CircleEmpty,

    /**
     * Icon 'circleInfo'
     */
    CircleInfo,

    /**
     * Icon 'comment'
     */
    Comment,

    /**
     * Icon 'compass'
     */
    Compass,

    /**
     * Icon 'contactCardSettings'
     */
    ContactCardSettings,

    /**
     * Icon 'copy'
     */
    Copy,

    /**
     * Icon 'declined'
     */
    Declined,

    /**
     * Icon 'delete'
     */
    Delete,

    /**
     * Icon 'devices3'
     */
    Devices3,

    /**
     * Icon 'diamond'
     */
    Diamond,

    /**
     * Icon 'document'
     */
    Document,

    /**
     * Icon 'download'
     */
    Download,

    /**
     * Icon 'ellipsis'
     */
    Ellipsis,

    /**
     * Icon 'excelLogo'
     */
    Excel,

    /**
     * Icon 'favoriteStar'
     */
    FavoriteStar,

    /**
     * Icon 'filter'
     */
    Filter,

    /**
     * Icon 'filterSolid'
     */
    FilterSolid,

    /**
     * Icon 'folder'
     */
    Folder,

    /**
     * Icon 'folderOpen'
     */
    FolderOpen,

    /**
     * Icon 'giftCard'
     */
    GiftCard,

    /**
     * Icon 'group'
     */
    Group,

    /**
     * Icon 'hide'
     */
    Hide,

    /**
     * Icon 'highLander'
     */
    HighLander,

    /**
     * Icon 'link'
     */
    Link,

    /**
     * Icon 'listBullets'
     */
    ListBullets,

    /**
     * Icon 'location'
     */
    Location,

    /**
     * Icon 'mail'
     */
    Mail,

    /**
     * Icon 'minus'
     */
    Minus,

    /**
     * Icon 'move'
     */
    Move,

    /**
     * Icon 'news'
     */
    News,

    /**
     * Icon 'office2'
     */
    Office2,

    /**
     * Icon 'officeForms'
     */
    OfficeForms,

    /**
     * Icon 'officeStore'
     */
    OfficeStore,

    /**
     * Icon 'officeThreshold'
     */
    OfficeThreshold,

    /**
     * Icon 'oneDriveLogo'
     */
    OneDrive,

    /**
     * Icon 'onenote2'
     */
    Onenote2,

    /**
     * Icon 'outlook'
     */
    Outlook,

    /**
     * Icon 'page'
     */
    Page,

    /**
     * Icon 'pencil'
     */
    Pencil,

    /**
     * Icon 'pencilSolid'
     */
    PencilSolid,

    /**
     * Icon 'people2'
     */
    People2,

    /**
     * Icon 'Permissions'
     */
    Permissions,

    /**
     * Icon 'sharepoint'
     */
    SharePoint,

    /**
     * Icon 'person'
     */
    Person,

    /**
     * Icon 'photoVideoMedia'
     */
    PhotoVideoMedia,

    /**
     * Icon 'pinDown'
     */
    PinDown,

    /**
     * Icon 'playerSettings'
     */
    PlayerSettings,

    /**
     * Icon 'playlistMusic'
     */
    PlaylistMusic,

    /**
     * Icon 'placeholder'
     */
    Placeholder,

    /**
     * Icon 'placeholder'
     */
    PollResults,

    /**
     * Icon 'powerBILogo'
     */
    PowerBI,

    /**
     * Icon 'powerpointLogo'
     */
    PowerPoint,

    /**
     * Icon 'preview'
     */
    Preview,

    /**
     * Icon 'previewLink'
     */
    PreviewLink,

    /**
     * Icon 'project'
     */
    Project,

    /**
     * Icon 'publisher'
     */
    Publisher,

    /**
     * Icon 'question'
     */
    Question,

    /**
     * Icon 'restore'
     */
    Restore,

    /**
     * Icon 'save'
     */
    Save,

    /**
     * Icon 'search'
     */
    Search,

    /**
     * Icon 'settings'
     */
    Settings,

    /**
     * Icon 'share2'
     */
    Share2,

    /**
     * Icon 'skypeForBusiness'
     */
    SkypeForBusiness,

    /**
     * Icon 'sortDown'
     */
    SortDown,

    /**
     * Icon 'sortUp'
     */
    SortUp,

    /**
     * Icon 'stream'
     */
    Stream,

    /**
     * Icon 'sway'
     */
    Sway,

    /**
     * Icon 'sync'
     */
    Sync,

    /**
     * Icon 'system'
     */
    System,

    /**
     * Icon 'task'
     */
    Task,

    /**
     * Icon 'teams'
     */
    Teams,

    /**
     * Icon 'tentativelyAccepted'
     */
    TentativelyAccepted,

    /**
     * Icon 'textDocument'
     */
    TextDocument,

    /**
     * Icon 'tileView'
     */
    TileView,

    /**
     * Icon 'to do'
     */
    ToDo,

    /**
     * Icon 'trending12'
     */
    Trending,

    /**
     * Icon 'unfavorite'
     */
    Unfavorite,

    /**
     * Icon 'unpin'
     */
    Unpin,

    /**
     * Icon 'video'
     */
    Video,

    /**
     * Icon 'video'
     */
    Visio,

    /**
     * Icon 'upload'
     */
    Upload,

    /**
     * Icon 'waffle'
     */
    Waffle,

    /**
     * Icon 'wordLogo'
     */
    Word,

    /**
     * Icon 'x'
     */
    X,

    /**
     * Icon 'x2'
     */
    X2

    /* END GENERATED CODE */
}
